import { forwardRef, Ref } from 'react';

import { Amount, AmountProps } from './Amount';

type Props = AmountProps;

const AmountUsdComponent = (
  { value, opts, ...props }: Props,
  ref: Ref<HTMLParagraphElement>,
) => {
  return (
    <Amount
      ref={ref}
      {...props}
      value={value}
      opts={{
        prefix: props.prefix ?? '$',
        ...opts,
      }}
    />
  );
};
export const AmountUsd = forwardRef(AmountUsdComponent);
